import SiteNav from "@/components/feature/SiteNav";
import Hero from "./components/Hero";
import Philosophy from "./components/Philosophy";
import Features from "./components/Features";
import Specs from "./components/Specs";
import Gallery from "./components/Gallery";
import Preorder from "./components/Preorder";
import SiteFooter from "@/components/feature/SiteFooter";

export default function Home() {
  return (
    <main className="min-w-[1024px] w-full min-h-screen bg-background-50 text-foreground-950">
      <div className="flex flex-col h-screen">
        <SiteNav />
        <Hero />
      </div>
      <Philosophy />
      <Features />
      <Specs />
      <Gallery />
      <Preorder />
      <SiteFooter />
    </main>
  );
}